import React from "react";
import ReactDOM from "react-dom";
import {
  Marker,
  Popup,
  Direction,
  MarkerLayer,
} from "../../../../../lib/Map";
import {
  getDispatchLastStop,
  getDispatchWayPoints,
  getDispatchRouteStopsMarker,
  getDispatchUnassignedPickupMarker,
  getDispatchAssignedPickupMarker,
  getDispatchDriverMarker,
} from "../../../../mapComponents/mapHelper";
import {
  DispatchStopPickupPopupInfo,
  DispatchStopDeliveryPopupInfo,
} from "../../../../mapComponents/Popups";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import { withSnackbar } from "notistack";
import { TerminalMarker } from "../../../../mapComponents/Markers";
import MapsHelper from "../../../../../lib/Map/helper";
import Events from "../../../../../utilities/EventEmitter";
import appConstants from "../../../../../appConstants";
import DriverRecommendations from "../Recommendations";
import DriverPopup from "../DriverPopUp";
import MapLegend from "./components/MapLegend";
import PickupAssignmentLasso from "./PickupAssignmentLasso";
import GeocodingModal from "../../../Common/Geocoding/GeoCodingModal";
import {
  getPickupCustomerData,
  getStopCustomerData,
} from "../../../Common/Geocoding/utils";
import {
  getDriverMapConfig,
  isDriverDelayed,
  isDelayStop,
  isPickupOnMapActive,
  getStopMarkerColors,
  getPickupStopData,
  isPickupDriverExistInGrid,
  isPickupUnassigned,
  checkPickupExists,
  getUnassignMarkerInfo,
  getPickupsRouteData,
} from "./utils";
import { assignPickup, unassignPickup } from "../utils/pickupActions";
import { isFuturePickup, isNotAssignedPickup } from "../filterUtils";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";
import {
  getPickupStatus,
} from "../utils/pickupStatusTypeIcon";
import { getSpecialNeeds } from "../../../utils";
import { PICKUP_STATUS } from "../constants";
import { WithPickupsGridFilterHOC } from "../Pickups/Grid/Filter";
import PickupPopupInfo from "./components/PickupPopupInfo";
import SpottedTrailers from "./SpottedTrailers";

@inject("DispatchStore")
@observer
class DriverMapContent extends React.Component {
  constructor(props) {
    super(props);
    this.headerId = `gridHeader_${this.props.glContainer._config.id}`;
    this.pickupSelectedOnMap = false;
    this.driversMapConfig = getDriverMapConfig(
      this.props.userData.userProfile?.columnPref
    );
    this.props.forwardedRef(this);
    this.state = {
      selectedPickups: [],
      routeSelected: null,
      routeAnimation: this.driversMapConfig.toggles.isRouteAnimationEnabled,
      mapLegend: this.driversMapConfig.toggles.isMapLegendEnabled,
      selectedStop: null,
      selectedPickup: null,
      recommendationPickupId: null,
      geocodeCustomer: null,
      lassoUnassignedPickups: [],
    };
    this.showRouteAnimation = false;
    this.enableChangePickupTerminal = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableChangePickupTerminal
    );
  }
  componentDidMount() {
    const { glEventHub } = this.props;
    glEventHub.on(appConstants.Event.PICKUP_SELECTED_GRID, this.pickupSelected);
    glEventHub.on(
      appConstants.Event.DISPATCH_ROUTE_SELECTED,
      this.routeSelectedOnGrid
    );
    glEventHub.on(this.headerId + "_multiSelectSelected", this.filterMapData);
    glEventHub.on("routeAnimation", this.routeAnimation);
    glEventHub.on(`${this.headerId}_geocode`, this.showGeocode);
    glEventHub.on("pickupsGridFilterChanged", this.filterPickupsOnMap);
    glEventHub.on("showRouteAnimationOnSelection", this.handleRouteAnimation);
    glEventHub.on(
      "closePickupAssignmentLasso",
      this.closePickupAssignmentLasso
    );
    Events.on(
      "showAssignPickupNotification",
      this.handleAssignPickupNotification
    );
    this.getPickupTerminalList();
    !this.props.DispatchStore.pickupsFilter && //on map popout, pickups filter is reset in store , therefore we need to update pickups filter to default filter(client specific) when map mounts in new window.
      this.props.DispatchStore.updatePickupsFilter(this.props.defaultFilter);
  }
  componentWillUnmount() {
    const { glEventHub } = this.props;
    glEventHub.off(
      appConstants.Event.PICKUP_SELECTED_GRID,
      this.pickupSelected
    );
    glEventHub.off(
      appConstants.Event.DISPATCH_ROUTE_SELECTED,
      this.routeSelectedOnGrid
    );
    glEventHub.off(this.headerId + "_multiSelectSelected", this.filterMapData);
    glEventHub.off("pickupsGridFilterChanged", this.filterPickupsOnMap);
    glEventHub.off("routeAnimation", this.routeAnimation);
    glEventHub.off(`${this.headerId}_geocode`, this.showGeocode);
    glEventHub.off("showRouteAnimationOnSelection", this.handleRouteAnimation);
    glEventHub.off(
      "closePickupAssignmentLasso",
      this.closePickupAssignmentLasso
    );
    Events.removeListener(
      "showAssignPickupNotification",
      this.handleAssignPickupNotification
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selectedStop ||
      this.state.selectedPickup ||
      this.state.selectedPickups.length === 1
    ) {
      this.props.glEventHub.emit(`${this.headerId}_ActivateGeocode`, true);
    } else {
      this.props.glEventHub.emit(`${this.headerId}_ActivateGeocode`, false);
    }
    if (
      this.props.userData.userProfile.terminal.code !==
      prevProps.userData.userProfile.terminal.code
    ) {
      this.props.DispatchStore.updateSelectedDispatchDriver([]);
      this.hideAllPopups();
      this.hidePickupRecommendation();
      this.closePickupAssignmentLasso();
      this.getPickupTerminalList();
    }
  }
  showGeocode = () => {
    if (this.state.selectedStop?.data?.isStopCompleted) {
      this.props.enqueueSnackbar(`Not allowed to geocode a completed stop`, {
        variant: "error",
      });
      return;
    }
    this.setState({
      geocodeCustomer: this.getGeocodeCustomer(),
    });
  };

  closeGeocodeModal = (locationUpdated) => {
    this.setState({
      geocodeCustomer: null,
      ...(locationUpdated ? { selectedPickup: null } : {}),
    });
  };

  filterMapData = (options) => {
    const filteredValuesList = options.map((opt) => opt.value);
    this.populateCollectedFilters(filteredValuesList);
  };

  populateCollectedFilters = (selectedOptions) => {
    this.props.DispatchStore.updateMapFilter(selectedOptions);
  };

  filterPickupsOnMap = (option) => {
    this.props.DispatchStore.updatePickupsFilter(option);
    this.setState({
      selectedPickup: null,
    });
  };

  pickupSelected = (selectedPickupsList) => {
    this.pickupSelectedOnMap = false;
    this.setState({
      selectedPickups: selectedPickupsList.pickupsData,
      selectedPickup: null,
      recommendationPickupId: null,
    });
  };

  routeSelectedOnGrid = (routeSelectedList) => {
    this.setState((state) => ({
      selectedStop: null,
      selectedPickup:
        state.recommendationPickupId ||
        routeSelectedList.includes(state.selectedPickup?.data?.routeId)
          ? state.selectedPickup
          : null,
    }));
  };
  onScaleDrawingComplete = (bounds, isNewLasso = true) => {
    this.lassoBounds = bounds;
    const unassignedPickups = this.props.DispatchStore.filteredPickups
      .slice()
      .filter((pickup) =>
        isNotAssignedPickup({
          pickup,
          terminalOffset: this.props.DispatchStore.terminalOffset,
        })
      )
      .map((pickup) => ({
        ...pickup,
        latitude: pickup.shipperLatitude,
        longitude: pickup.shipperLongitude,
      }));
    const lassoUnassignedPickups = MapsHelper.getLocationWithinBounds(
      bounds,
      unassignedPickups
    );
    this.setState({
      lassoUnassignedPickups,
    });
  };

  closePickupAssignmentLasso = () => {
    this.lassoBounds = [];
    this.setState({
      lassoUnassignedPickups: [],
    });
  };

  routeAnimation = (routeAnimation) => {
    this.setState({
      routeAnimation,
    });
  };

  onPickupMarkerClicked = (pickup) => {
    this.pickupSelectedOnMap = true;
    this.setState({
      selectedPickups: [pickup.data],
      selectedPickup: pickup,
      recommendationPickupId: null,
    });
    this.props.glEventHub.emit(appConstants.Event.PICKUP_SELECTED_MAP, [
      pickup.data.pickupId,
    ]);
  };

  onRouteStopClicked = (stop) => {
    this.stopSelectedOnMap = true;
    this.pickupSelectedOnMap = false;
    this.setState({
      selectedStop: stop,
    });
  };

  openMessageChatBox = (e, driverId) => {
    e.stopPropagation();
    this.props.glEventHub.emit(
      "OpenDriverChatBox",
      JSON.stringify({ driverId })
    );
  };

  hidePickupRecommendation = () => {
    this.setState({
      recommendationPickupId: null,
    });
  };

  handleAssignPickupNotification = (eventData, eventName) => {
    const route = getPickupsRouteData(
      this.props.DispatchStore.routesList,
      eventData
    );

    const pickup = this.props.DispatchStore.pickupsList.find(
      (p) => p.pickupId === eventData.pickupId
    );
    const enableRouteSelection = this.props.configJSON?.routeSelection;
    if (route && pickup) {
      if (eventName === appConstants.PICKUP_EVENTS.ASSIGN_PICKUP) {
        if (eventData.success) {
          this.props.enqueueSnackbar(
            `Pickup ${pickup.shipperName} (${pickup.pickupNumber}) assigned to route ${route.routeName}`,
            { variant: "success" }
          );
          !enableRouteSelection &&
            this.updatePickupSelection(eventData.pickupId);
        } else {
          this.props.enqueueSnackbar(
            `Failed to assign pickup ${pickup.shipperName} (${pickup.pickupNumber}) to driver ${route.driverName}`,
            { variant: "error" }
          );
        }
      } else if (eventName === appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP) {
        if (eventData.success) {
          this.props.enqueueSnackbar(
            `Pickup ${pickup.shipperName} (${pickup.pickupNumber}) unassigned from route ${route.routeName}`,
            { variant: "success" }
          );
          !enableRouteSelection &&
            this.updatePickupSelection(eventData.pickupId);
        } else {
          this.props.enqueueSnackbar(
            `Failed to unassign pickup ${pickup.shipperName} (${pickup.pickupNumber}) from driver ${route.driverName}`,
            { variant: "error" }
          );
        }
      }
    }
  };

  updatePickupSelection = (pickupId) => {
    const newSelectedPickups = this.state.selectedPickups.filter(
      (pickup) => pickup.pickupId !== pickupId
    );
    this.setState({ selectedPickups: newSelectedPickups });
    this.props.glEventHub.emit(
      appConstants.Event.PICKUP_SELECTED_MAP,
      newSelectedPickups.map((pickup) => pickup.pickupId),
      false //refreshDriverSelection
    );
  };

  handleRecommendationsCloseButtonClick = () => {
    this.setState({
      recommendationPickupId: null,
    });
  };

  assignPickupToDriver = (driverId, pickupId) => {
    this.closePickupAssignmentLasso();
    assignPickup({
      pickupIds: [pickupId],
      driverId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
    }).then(() => {
      this.setState({
        selectedPickup: null,
        recommendationPickupId: null,
      });
    });
  };

  unAssignDriver = ({ pickupId, driverId }) => {
    this.closePickupAssignmentLasso();
    unassignPickup({
      pickupIds: [pickupId],
      driverId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
    }).then(() => {
      this.setState({
        selectedPickup: null,
      });
    });
  };

  onRecommendationsButtonClick = (pickupId) => {
    this.setState({
      recommendationPickupId: pickupId,
    });
  };

  hideAllPopups = () => {
    if (
      this.state.selectedStop ||
      this.state.isPickupMove ||
      this.state.selectedPickup
    ) {
      this.setState({
        selectedStop: null,
        isPickupMove: false,
        selectedPickup: null,
      });
    }
    this.stopSelectedOnMap = false;
    this.pickupSelectedOnMap = false;
    Events.emit("RemoveMapPopup");
  };

  getGeocodeCustomer = () => {
    if (this.state.selectedStop?.data) {
      // Pickup or delivery Stops
      return getStopCustomerData(this.state.selectedStop.data);
    } else {
      // For unassigned Pickups
      const unassignedPickupId =
        this.state.selectedPickup?.data?.pickupId ||
        this.state.selectedPickups[0].pickupId;
      const unassignedPickup = this.props.DispatchStore.pickupsList.find(
        (pickup) =>
          pickup.pickupId.toLowerCase() === unassignedPickupId.toLowerCase()
      );

      if (!unassignedPickup) {
        return null;
      }
      return getPickupCustomerData(unassignedPickup);
    }
  };

  getPickupTerminalList = () => {
    getDataWithQueryString(
      "GetTerminalsToMovePickup",
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((response) => {
        if (response.status === 200) {
          this.props.DispatchStore.setMovePickupTerminalList(response.data);
        } else {
          this.props.DispatchStore.setMovePickupTerminalList([]);
        }
      })
      .catch((error) => {
        this.props.DispatchStore.setMovePickupTerminalList([]);
      });
  };

  onDriverIconClick = (route) => {
    this.props.glEventHub.emit(
      "SelectDriverRoutes",
      [route.data.driverId],
      false,
      true,
      this.showRouteAnimation
    );
  };

  disableRouteAnimation = () => {
    if (this.showRouteAnimation) {
      this.handleRouteAnimation(false);
    }
  };

  handleRouteAnimation = (showRouteAnimation) => {
    this.showRouteAnimation = showRouteAnimation;
  };

  getMarkerLayerCenter = () => {
    // If a single marker is slected on grid or on Map move map to make that shipment as center
    const { selectedPickup, selectedPickups } = this.state;
    if (selectedPickup) {
      return {
        lat: selectedPickup.data.shipperLatitude,
        lng: selectedPickup.data.shipperLongitude,
      };
    }
    if (selectedPickups.length) {
      return selectedPickups.at(-1).position;
    }
    return null;
  };

  getPickupIcon = (pickup) => {
    const { theme } = this.props;
    const isPickupActive = isPickupOnMapActive(
      this.state.selectedPickups,
      pickup.pickupId
    );
    let marker = "";
    if (
      pickup.driverId &&
      isPickupDriverExistInGrid(
        this.props.DispatchStore.currentActiveRoutes,
        pickup.driverId,
        pickup.routeId
      )
    ) {
      const pickupStop = getPickupStopData(
        this.props.DispatchStore.routesList,
        pickup
      );
      marker = getDispatchAssignedPickupMarker({
        pickup: pickup,
        stopData: pickupStop?.stopData,
        isPickupActive: isPickupActive,
        stopSequence: pickupStop?.stopData?.stopSequence,
        color: pickupStop?.stopColor,
        borderColor: theme.routeMapColorPalette.MarkerBorderColor,
        markerTextColor: theme.routeMapColorPalette.MarkerTextColor,
      });
    } else {
      marker = getDispatchUnassignedPickupMarker(
        getUnassignMarkerInfo({
          pickup,
          isPickupActive,
          theme,
          terminalOffset: this.props.DispatchStore.terminalOffset,
        })
      );
    }
    return marker;
  };

  getDrivers = () => {
    const {
      showAllDrivers,
      currentActiveRoutes,
      routesWithFilteredStops,
      driverLocations,
    } = this.props.DispatchStore;
    const driverRoutes =
      routesWithFilteredStops.length === 0 || showAllDrivers
        ? currentActiveRoutes
        : routesWithFilteredStops;

    const driverIds = driverRoutes.map((d) => d.driverId.toUpperCase());

    return Object.keys(driverLocations)
      .map((driverId) => ({ driverId, ...driverLocations[driverId] }))
      .filter(
        (driverLoc) =>
          driverIds.includes(driverLoc.driverId) &&
          driverLoc.latitude &&
          driverLoc.longitude
      );
  };

  isDriverRouteShown = (driverId) => {
    return (
      this.props.DispatchStore.routesWithFilteredStops.findIndex(
        (route) => route.driverId === driverId
      ) > -1
    );
  };

  getVisiblePickups = () => {
    const { routesWithFilteredStops, filteredPickups } =
      this.props.DispatchStore;
    const visibleRouteIds = routesWithFilteredStops.map((route) =>
      route.routeId?.toLowerCase()
    );
    return filteredPickups
      .filter(
        (pickup) => !visibleRouteIds.includes(pickup.routeId?.toLowerCase())
      )
      .map((pickup) => ({
        ...pickup,
        latitude: pickup.shipperLatitude,
        longitude: pickup.shipperLongitude,
      }));
  };

  getMarkerLabel = (pickup) => {
    const pickupStatus = getPickupStatus(
      pickup,
      this.props.DispatchStore.terminalOffset
    );
    if (
      [PICKUP_STATUS.completed, PICKUP_STATUS.voided].includes(pickupStatus)
    ) {
      return null;
    }
    return `${pickup.pickupReadyTime}
            ${pickup.pickupCloseTime}`;
  };

  getMarkerLabelProps = () => {
    return {
      layout: {
        "text-offset": [-1.5, 0.3],
        "text-anchor": "right",
        "text-size": 10,
      },
      paint: {
        "text-color":
          this.props.theme.themeName === "dark" ? "#FFFFFF" : "#000000",
        "text-opacity": 0.8,
      },
    };
  };

  showPickupPopup = (selectedPickup) => {
    return (
      selectedPickup &&
      this.pickupSelectedOnMap &&
      checkPickupExists({
        filteredPickups: this.props.DispatchStore.filteredPickups,
        selectedPickupsList: this.props.DispatchStore.selectedPickupsList,
        pickupId: selectedPickup.data.pickupId,
      }) &&
      !selectedPickup.driverId
    );
  };

  getCenterOffset = (showStopList) => {
    if (this.state.recommendationPickupId) {
      return showStopList ? [-210, 0] : [-240, 0];
    }
    return [0, 0];
  };

  render() {
    const {
      theme,
      DispatchStore,
      userData: { userProfile },
      glEventHub,
    } = this.props;
    const { selectedPickup, selectedStop, recommendationPickupId } = this.state;
    const specialNeeds = getSpecialNeeds(DispatchStore.priorityAllShipmentList);
    const { offset, location: terminalLocation } = userProfile.terminal;
    const selectedDispatchDriverIdList =
      DispatchStore.selectedDispatchDriverIdList;
    let selectedRoutes = DispatchStore.routesWithFilteredStops.slice();
    let selectedDriversWithDispatch = [];
    let routesData;
    if (selectedPickup?.data?.driverId) {
      routesData = DispatchStore.getCurrentDriver(
        selectedPickup?.data?.driverId
      );
    } else if (selectedStop) {
      routesData = DispatchStore.getCurrentDriver(selectedStop.data.driverId);
    }
    if (selectedDispatchDriverIdList.length) {
      selectedDriversWithDispatch =
        DispatchStore.getSelectedDriverCurrentRoutes().map((route) => ({
          ...route,
          filteredStops: [],
          routeId: "",
        }));
    }

    const showStopList =
      selectedRoutes?.length === 1 || selectedDriversWithDispatch.length === 1;

    const futurePickup = isFuturePickup(
      selectedPickup?.data.pickupDate,
      DispatchStore.terminalOffset
    );

    let isPickupStopPopup = false,
      isDeliveryStopPopup = false,
      stopPopupCommonProps = {};
    if (this.stopSelectedOnMap && selectedStop) {
      isPickupStopPopup =
        selectedStop?.data?.stopType === appConstants.STOP_TYPE.Pickup;
      isDeliveryStopPopup =
        selectedStop?.data?.stopType === appConstants.STOP_TYPE.Delivery;
      stopPopupCommonProps = {
        glEventHub,
        theme: this.props.theme.themeName,
        stopData: selectedStop.data,
        routesData,
        specialNeeds,
        isDelayStop: isDelayStop(selectedStop.data),
        terminalOffset: offset,
        openDriverChat: this.openMessageChatBox,
      };
    }
    return (
      <div>
        {showStopList && (
          <DriverPopup
            routeData={selectedRoutes?.[0] || selectedDriversWithDispatch[0]}
            userProfile={userProfile}
            glEventHub={glEventHub}
            defaultExpanded={false}
          />
        )}

        {recommendationPickupId &&
          checkPickupExists({
            filteredPickups: DispatchStore.filteredPickups,
            selectedPickupsList: DispatchStore.selectedPickupsList,
            pickupId: recommendationPickupId,
          }) &&
          isPickupUnassigned(
            DispatchStore.selectedPickupsList,
            recommendationPickupId
          ) && (
            <DriverRecommendations
              handleClose={this.handleRecommendationsCloseButtonClick}
              pickupId={recommendationPickupId}
              assignPickup={this.assignPickupToDriver}
              glEventHub={glEventHub}
            />
          )}
        <Marker
          position={terminalLocation}
          zIndex={1}
          forceUpdate
          isActiveShipment
          easeToAnimation
          mapZoomLevel={appConstants.MAP_ZOOM_LEVEL}
        >
          <TerminalMarker
            data={userProfile.terminal}
            color={theme.terminalContentColor}
          />
        </Marker>

        <MarkerLayer
          code={this.props.userData.userProfile.terminal.code}
          data={this.getVisiblePickups()}
          dataKey={"pickupId"}
          activeMarkerIds={this.state.selectedPickups.map(
            (pickup) => pickup.pickupId
          )}
          thresholdZoomLevel={11}
          getIcon={this.getPickupIcon}
          center={this.getMarkerLayerCenter()}
          onClick={(pickup) => this.onPickupMarkerClicked({ data: pickup })}
          getMarkerLabel={this.getMarkerLabel}
          centerOffset={this.getCenterOffset(showStopList)}
          applyOffset={Boolean(recommendationPickupId)}
          markerLabelProps={this.getMarkerLabelProps()}
          showTooltip={false}
        />

        <SpottedTrailers
          headerId={this.headerId}
          glEventHub={this.props.glEventHub}
          terminalCode={userProfile.terminal.code}
        />

        {selectedRoutes?.map((route) => {
          const driverLocation = this.props.DispatchStore.getDriverLatLng(
            route.driverId
          );
          return (
            <Direction
              origin={driverLocation ? null : terminalLocation}
              destination={getDispatchLastStop(route.filteredStops)}
              waypoints={
                getDispatchWayPoints(route.filteredStops) ?? [
                  { location: terminalLocation },
                ]
              } // Add terminal coordinates to waypoint list in case driver route is present but filtered stops list is empty
              strokeColor={route.color}
              data={route}
              key={route.routeId} //routeId changes for each update which will unmount this component
              zIndex={0}
              onAnimationDone={this.disableRouteAnimation}
              routeAnimation={Boolean(
                this.state.routeAnimation && this.showRouteAnimation
              )}
              enableRouteHover
              driverLocation={driverLocation}
            />
          );
        })}

        {this.getDrivers()?.map((driver) => {
          const driverData = this.props.DispatchStore.getCurrentDriver(
            driver.driverId
          );
          return (
            <Marker
              position={this.props.DispatchStore.getDriverLatLng(
                driver.driverId
              )}
              zIndex={this.isDriverRouteShown(driver.driverId) ? 1 : 0}
              key={driver.driverId}
              data={driver}
              onClick={this.onDriverIconClick}
            >
              {getDispatchDriverMarker({
                data: driverData,
                isDelayed: isDriverDelayed(driverData),
                theme,
                onMessageIconClick: this.openMessageChatBox,
              })}
            </Marker>
          );
        })}

        {selectedRoutes?.map((route) =>
          route.filteredStops?.map((stop) => (
            <Marker
              data={{ ...stop }}
              position={{ lat: stop.latitude, lng: stop.longitude }}
              key={`${stop.stopId}_${stop.stopSequence}`}
              zIndex={stop.stopId === selectedStop?.data?.stopId ? 2 : 1}
              onClick={this.onRouteStopClicked}
            >
              {getDispatchRouteStopsMarker({
                stop,
                ...getStopMarkerColors({
                  theme,
                  stop,
                  routeColor: route.color,
                }),
                isSelectedStop: Boolean(
                  selectedStop?.data?.stopId === stop.stopId
                ),
              })}
            </Marker>
          ))
        )}
        <MapLegend
          defaultVisible={this.driversMapConfig.toggles.isMapLegendEnabled}
          glEventHub={this.props.glEventHub}
        />

        {this.showPickupPopup(selectedPickup) && (
          <Popup
            position={{
              lat: selectedPickup.data.latitude,
              lng: selectedPickup.data.longitude,
            }}
            key={`${selectedPickup.data.pickupId}_pickupPopup`}
          >
            <PickupPopupInfo
              theme={theme}
              specialNeeds={specialNeeds}
              routesData={routesData}
              selectedPickup={selectedPickup.data}
              showAction={
                !(
                  futurePickup ||
                  selectedPickup.data.isCompleted ||
                  selectedPickup.data.isVoided ||
                  selectedPickup.data.isMissed
                )
              }
              terminal={userProfile.terminal}
              enableChangePickupTerminal={this.enableChangePickupTerminal}
              routesList={DispatchStore.routesList}
              currentActiveRoutes={DispatchStore.currentActiveRoutes}
              unAssignDriver={this.unAssignDriver}
              openMessageChatBox={this.openMessageChatBox}
              onRecommendationsButtonClick={this.onRecommendationsButtonClick}
              terminalCodeList={this.props.DispatchStore.movePickupTerminalList}
              glEventHub={this.props.glEventHub}
            />
          </Popup>
        )}

        {isDeliveryStopPopup && (
          <Popup
            marker={selectedStop.marker}
            // forceRender will rerender the child component into the infowindow,
            // set to true when theme changes or data is updated for selected shipment
            // forceRender={this.state.themeChanged}
          >
            <DispatchStopDeliveryPopupInfo {...stopPopupCommonProps} />
          </Popup>
        )}

        {isPickupStopPopup && (
          <Popup
            key={selectedStop.stopId}
            marker={selectedStop.marker}
            // forceRender will rerender the child component into the infowindow,
            // set to true when theme changes or data is updated for selected shipment
            // forceRender={this.state.themeChanged}
          >
            <DispatchStopPickupPopupInfo
              {...stopPopupCommonProps}
              hideAction={selectedStop.data.isStopCompleted}
              unAssignDriver={this.unAssignDriver}
              pickupNumber={selectedStop.data.pickupNumber}
            />
          </Popup>
        )}

        {this.lassoBounds?.length ? (
          ReactDOM.createPortal(<PickupAssignmentLasso
            unassignedPickups={this.state.lassoUnassignedPickups}
            userProfile={userProfile}
            glEventHub={glEventHub}
            close={this.closePickupAssignmentLasso}
          />, document.getElementById("dispatchMapContainer"))
        ) : null}

        {this.state.geocodeCustomer ? (
          <GeocodingModal
            customer={this.state.geocodeCustomer}
            userData={userProfile}
            close={this.closeGeocodeModal}
          />
        ) : null}
      </div>
    );
  }
}

export default compose(
  withSnackbar,
  withFeatureFlags,
  WithPickupsGridFilterHOC
)(DriverMapContent);
